import classNames from 'classnames';
import NavbarAssessment from 'components/navbars/navbar-assessment/NavbarAssessment';
import { useAssessmentLayoutContext } from 'providers/AssessmentLayoutProvider';
import React from 'react';
import { Outlet } from 'react-router-dom';

function QuizHeader() {
  const { contentClass } = useAssessmentLayoutContext();

  return (
    <>
      <NavbarAssessment />
      <div className={classNames(contentClass, 'content')}>
        <Outlet />
      </div>
    </>
  );
}

export default QuizHeader;
